import { useEffect, useRef, useState } from 'react';
import SidePanel from '../../side-panel/side-panel';
import ButtonPrimary from '../../button/button-primary';
import ButtonPseudo from '../../button/button-pseudo';
import { SidePanelType } from '../../side-panel/types';
import {
  BaseellaStatus,
  BlacklistData,
  CustomerType,
  DocumentStatus,
  EnumTabs,
  BlacklistUserInfoData,
} from '../types';
import IncomingTransactionSidepanelContentRead from '../incoming-outgoing-transaction-sidepanel-read';
import IncomingTransactionSidepanelContentForm from './incoming-transaction-sidepanel-content-form';
import SidePanelLoader from '../../side-panel/loader';
import Popup from '../../popup/popup';
import SignaturePopup from '../signature-popup';
import PermissionDenied from '../../permission-denied/permission-denied';
import BlacklistDataContent from '../warnings/blacklist-data-content';
import BlacklistUserInfo from '../warnings/blacklist-user-info';
import { PermissionEnum } from '../../../base-types';
import DocumentSidePanel from '../documents/document-sidepanel';
import ButtonSecondary from '../../button/button-secondary';
import GeneralLedgerSidepanel from '../general-ledger/general-ledger-sidepanel';
import { IncomingTransactionSidepanelTypes } from './types';
import usePrevious from '../../../hooks/use-previous';

import styles from '../transaction.module.css';

export default function IncomingTransactionSidepanel({
  tabs,
  panelIsOpen,
  handleClose,
  title,
  statusesInfo,
  onRollbackStatus,
  onNextStatus,
  handleSubmit,
  isLoading,
  enableEdit = false,
  feeText,
  control,
  isDisabledSaveButton,
  transactionInfo,
  amlInfo,
  currencies,
  paymentsTypes,
  countries,
  children,
  errors,
  isEditable = true,
  recipientAccounts,
  pspPartnerAccounts,
  pspPartners,
  onSearchAutocomplete,
  pspPartnersIsLoading,
  recipientAccountsIsLoading,
  pspPartnerAccountsIsLoading,
  pspPartnerIsFilled = false,
  paymentTypeIsFilled = false,
  baseellaStatus,
  logs,
  warnings,
  employee,
  isCreateForm,
  paymentType,
  onApplyTransactionAction,
  onScrollToPaymentType,
  changeLogs,
  accountBalance,
  currencyId,
  balanceIsLoading,
  updateBalance,
  updatePspPartnerBalance,
  updateExternalBalance,
  pspPartnerAccountBalance,
  pspPartnerBalanceIsLoading,
  isDirty,
  checkInProgress,
  onChangeStatusPopup,
  statusPopupVisible,
  setStatusPopupVisible,
  validateCode,
  signaturePopupVisible,
  sendCode,
  validateCodeInProgress,
  transactionId,
  signatures,
  errorSidepanel,
  setRejectPopupVisible,
  onReject,
  rejectInProgress,
  rejectPopupVisible,
  transferDate,
  errorMessageSignature,
  createAllowed,
  transactionsTypes,
  updateStatusIsLoading,
  isLoadingStatuses,
  checkError,
  transactionCheckError,
  activePermission,
  onSignatureCancelClick,
  amount,
  setAmount,
  latestQueuedStatus,
  createdByOrganizationId,
  setValue,
  statusChangeError,
  onChangeStatusPopupLoading,
  applyTransactionsWarningIsLoading,
  chats,
  companyOfficials,
  onCreateTransactionChat,
  chatCreateInProgress,
  currentEmployee,
  createChatWithMessage,
  documents,
  document: documentItem,
  documentFileIsLoading,
  downloadInProgress,
  imgLink,
  onDelete,
  deleteInProgress,
  onMove,
  moveInProgress,
  onDownload,
  onDownloadSuccess,
  deleteIsVisible,
  sendComment,
  editComment,
  editCommentInProgress,
  editCommentIsSuccess,
  deleteComment,
  deleteCommentInProgress,
  commentInProgress,
  statusChangeInProgress,
  changeCustomerDocumentsStatus,
  onUploadDocument,
  uploadDocumentInProgress,
  uploadDocumentIsSuccess,
  uploadDocumentErrors,
  glTransactionsIsLoading,
  glTransactions,
  onGlTransactionClick,
  glTransactionIsLoading,
  glTransaction,
  clearGlTransactionState,
  getTransactionDocument,
  documentIsLoading,
  deleteIsSuccess,
  sendMessage,
  expandedGLTransactionCreditBalance,
  expandedGLTransactionDebitBalance,
  expendedDebitBalanceIsLoading,
  expendedCreditBalanceIsLoading,
  deleteTransactionError,
  onDeleteTransactions,
  deleteTransactionInProgress,
  deleteTransactionDisabled,
  createIsLoading,
  updateIsLoading,
  internalError,
  canSignTransaction,
  sendCodeInProgress,
  balances,
  accountBalancesIsLoading,
  currenciesList,
  onDuplicate,
  duplicate,
  fields,
  caspList,
  externalAccounts,
  externalAccountsIsLoading,
  onSearchExternalAccounts,
  onClearExternalAccounts,
  onGetExternalAccountsListAction,
  externalAccountsPagination,
  externalAccountsNextPageIsLoading,
  getTransactionDocuments,
  documentsIsLoading,
  getGeneralLedgerTransactionValues,
  getTransactionsChats,
  transactionChatsIsLoading,
  getCompanyOfficials,
  getSignaturesTransactionById,
  isLoadingSignatures,
  getIncomingTransactionByIdAml,
  isLoadingAml,
  getLogsTransactionById,
  isLoadingLogs,
  overdraftEnabled,
  recipientAccountsWithInfo,
  pspPartnersAccountsList,
  pspPartnerAccountBalanceInfo,
  getTransactionChangeLogs,
  changeLogsIsLoading,
  users,
  transactionChangeLogsPagination,
  changeLogsIsFetching,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  sidepanelExpandedKey,
  documentsPagination,
  documentsIsFetching,
  attachedDocumentsErrors,
  uploadedDocumentsErrors,
  transactionComments,
  transactionCommentsPagination,
  getTransactionCommentsAction,
  commentsIsLoading,
  commentsIsFetching,
  onAddCommentToTransaction,
  addCommentInProgress,
  addCommentIsSuccess,
  onEditCommentInTransaction,
  editTransactionCommentInProgress,
  editTrancastionCommentIsSuccess,
  onDeleteCommentInTransaction,
  deleteCommentInTransactionInProgress,
  deleteCommentInTranscationIsSuccess,
  getIncomingTransactionWarningById,
  isWarningByIdFetching,
  isWarningByIdLoading,
  warningsInfo,
  selectedWarningId,
  pspPartnerAccountsPagination,
  pspPartnerAccountsNextPageIsLoading,
  pspPartnerAccountsOnScroll,
  warningActionError,
  clearErrors,
  deleteDisabled,
  setWithTime,
  withTime,
}: IncomingTransactionSidepanelTypes): React.JSX.Element {
  const [dirtyPopupVisible, setDirtyPopupVisible] = useState(false);
  const [blacklistDataVisible, setBlacklistDataVisible] = useState(false);
  const [blacklistItemVisible, setBlacklistItemVisible] = useState(false);
  const [blacklistData, setBlacklistData] = useState<BlacklistData>();
  const [blacklistItem, setBlacklistDataItem] =
    useState<BlacklistUserInfoData>();
  const [transactionSidePanelVisible, setTransactionSidepanelVisible] =
    useState(panelIsOpen);
  const [selectedDocumentName, setSelectedDocumentName] = useState('');
  const [subPanelVisible, setSubPanelVisible] = useState(false);
  const [scroll, setScroll] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    DocumentStatus | undefined
  >(undefined);
  const [selectedDocumentId, setSelectedDocumentId] = useState('');
  const [activeTab, setActiveTab] = useState<EnumTabs>();
  const [glTransactionSidepanelVisible, setGlTransactionSidePanelVisible] =
    useState(false);
  const [deleteTransactionPopupVisible, setDeleteTransactionPopupVisible] =
    useState(false);
  const [confirmationPopupVisible, setConfirmationPopupVisible] =
    useState(false);

  const prevEditInProgress = usePrevious(updateIsLoading);

  const tabsItems = isCreateForm
    ? [
        { name: 'General Info', value: EnumTabs.GENERAL },
        { name: 'Order', value: EnumTabs.ORDER },
      ]
    : [
        { name: 'General Info', value: EnumTabs.GENERAL },
        { name: 'Order', value: EnumTabs.ORDER },
        { name: 'Warning', value: EnumTabs.WARNING },
        { name: 'AML & KYC', value: EnumTabs.AML },
        { name: 'Status log', value: EnumTabs.LOG },
        { name: 'Change Log', value: EnumTabs.CHANGE_LOG },
        { name: 'Signatures', value: EnumTabs.SIGNATURES },
        { name: 'Documents', value: EnumTabs.DOCUMENTS },
        { name: 'Accounting entries', value: EnumTabs.GL_TRANSACTIONS },
        { name: 'Chats', value: EnumTabs.CHATS },
        { name: 'Comments', value: EnumTabs.COMMENTS },
      ];

  const handleScroll = () => {
    setScroll((prev) => {
      if (prev !== Number(scrollRef.current?.scrollTop)) {
        return Number(scrollRef.current?.scrollTop);
      }
      return prev;
    });
  };

  useEffect(() => {
    const element = scrollRef.current;

    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  let content;
  let contentError;

  const handleCloseBlacklistData = () => {
    setBlacklistDataVisible(false);
    setBlacklistItemVisible(false);
    setBlacklistData(undefined);
    setBlacklistDataItem(undefined);
    setTransactionSidepanelVisible(true);
  };

  useEffect(() => {
    setTransactionSidepanelVisible(panelIsOpen);
  }, [panelIsOpen]);

  useEffect(() => {
    if (onDownloadSuccess && selectedDocumentId && !downloadInProgress) {
      setSelectedDocumentId('');
    }
  }, [onDownloadSuccess, selectedDocumentId, downloadInProgress]);

  useEffect(() => {
    if (deleteIsSuccess) {
      setDeletePopupVisible(false);
      setSubPanelVisible(false);
      setTransactionSidepanelVisible(true);
      setActiveTab(EnumTabs.DOCUMENTS);
    }
  }, [deleteIsSuccess]);

  useEffect(() => {
    if (!updateIsLoading && prevEditInProgress) {
      setConfirmationPopupVisible(false);
    }
  }, [updateIsLoading, prevEditInProgress]);

  if (isLoading && !internalError) {
    content = <SidePanelLoader />;
  } else if (enableEdit && !internalError) {
    if ((isCreateForm && createAllowed) || transactionId) {
      content = (
        <IncomingTransactionSidepanelContentForm
          statusesInfo={statusesInfo}
          updateStatusIsLoading={updateStatusIsLoading}
          onNextStatus={onNextStatus}
          onRollbackStatus={onRollbackStatus}
          control={control}
          transactionInfo={transactionInfo}
          amlInfo={amlInfo}
          currencies={currencies}
          paymentsTypes={paymentsTypes}
          countries={countries}
          errors={errors}
          isEditable={isEditable}
          recipientAccounts={recipientAccounts}
          pspPartnerAccounts={pspPartnerAccounts}
          pspPartners={pspPartners}
          onSearchAutocomplete={onSearchAutocomplete}
          pspPartnersIsLoading={pspPartnersIsLoading}
          recipientAccountsIsLoading={recipientAccountsIsLoading}
          pspPartnerAccountsIsLoading={pspPartnerAccountsIsLoading}
          pspPartnerIsFilled={pspPartnerIsFilled}
          paymentTypeIsFilled={paymentTypeIsFilled}
          baseellaStatus={baseellaStatus}
          logs={logs}
          warnings={warnings}
          employee={employee}
          onApplyTransactionAction={onApplyTransactionAction}
          changeLogs={changeLogs}
          isCreateForm={isCreateForm}
          onScrollToPaymentType={onScrollToPaymentType}
          paymentType={paymentType}
          feeText={feeText}
          accountBalance={accountBalance}
          currencyId={currencyId}
          balanceIsLoading={balanceIsLoading}
          updateBalance={updateBalance}
          updatePspPartnerBalance={updatePspPartnerBalance}
          pspPartnerBalanceIsLoading={pspPartnerBalanceIsLoading}
          pspPartnerAccountBalance={pspPartnerAccountBalance}
          signatures={signatures}
          sendCode={sendCode}
          sendCodeInProgress={sendCodeInProgress}
          setRejectPopupVisible={setRejectPopupVisible}
          transferDate={transferDate}
          transactionsTypes={transactionsTypes}
          setBlacklistDataVisible={(visible) => {
            setBlacklistDataVisible(visible);
            setTransactionSidepanelVisible(false);
          }}
          setBlacklistItemVisible={(visible) => {
            setBlacklistItemVisible(visible);
            setTransactionSidepanelVisible(false);
          }}
          setBlacklistData={setBlacklistData}
          setBlacklistDataItem={setBlacklistDataItem}
          parentRef={scrollRef}
          parentScroll={scroll}
          isLoadingStatuses={isLoadingStatuses}
          activePermission={activePermission}
          amount={amount}
          setAmount={setAmount}
          latestQueuedStatus={latestQueuedStatus}
          setValue={setValue}
          createdByOrganizationId={createdByOrganizationId}
          applyTransactionsWarningIsLoading={applyTransactionsWarningIsLoading}
          companyOfficials={companyOfficials}
          chats={chats}
          onCreateTransactionChat={onCreateTransactionChat}
          chatCreateInProgress={chatCreateInProgress}
          currentEmployee={currentEmployee}
          createChatWithMessage={createChatWithMessage}
          documents={documents}
          setSubPanelVisible={setSubPanelVisible}
          uploadDocumentInProgress={uploadDocumentInProgress}
          uploadDocumentIsSuccess={uploadDocumentIsSuccess}
          setSelectedDocumentName={setSelectedDocumentName}
          setTransactionSidepanelVisible={setTransactionSidepanelVisible}
          onUploadDocument={onUploadDocument}
          uploadDocumentErrors={uploadDocumentErrors}
          selectedDocumentId={selectedDocumentId}
          setSelectedDocumentId={setSelectedDocumentId}
          downloadInProgress={documentFileIsLoading || downloadInProgress}
          tabs={tabsItems}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          glTransactionsIsLoading={glTransactionsIsLoading}
          glTransactions={glTransactions}
          setGlTransactionSidePanelVisible={setGlTransactionSidePanelVisible}
          onGlTransactionClick={onGlTransactionClick}
          onDownloadDocument={onDownload}
          getTransactionDocument={getTransactionDocument}
          canSignTransaction={canSignTransaction}
          balances={balances}
          accountBalancesIsLoading={accountBalancesIsLoading}
          currenciesList={currenciesList}
          duplicate={duplicate}
          fields={fields}
          caspList={caspList}
          externalAccounts={externalAccounts}
          externalAccountsIsLoading={externalAccountsIsLoading}
          updateExternalBalance={updateExternalBalance}
          onSearchExternalAccounts={onSearchExternalAccounts}
          onClearExternalAccounts={onClearExternalAccounts}
          onGetExternalAccountsListAction={onGetExternalAccountsListAction}
          externalAccountsPagination={externalAccountsPagination}
          externalAccountsNextPageIsLoading={externalAccountsNextPageIsLoading}
          transactionId={transactionId}
          getTransactionDocuments={getTransactionDocuments}
          documentsIsLoading={documentsIsLoading}
          getGeneralLedgerTransactionValues={getGeneralLedgerTransactionValues}
          getTransactionsChats={getTransactionsChats}
          transactionChatsIsLoading={transactionChatsIsLoading}
          getCompanyOfficials={getCompanyOfficials}
          getSignaturesTransactionById={getSignaturesTransactionById}
          isLoadingSignatures={isLoadingSignatures}
          getIncomingTransactionByIdAml={getIncomingTransactionByIdAml}
          isLoadingAml={isLoadingAml}
          getLogsTransactionById={getLogsTransactionById}
          isLoadingLogs={isLoadingLogs}
          overdraftEnabled={overdraftEnabled}
          recipientAccountsWithInfo={recipientAccountsWithInfo}
          pspPartnersAccountsList={pspPartnersAccountsList}
          pspPartnerAccountBalanceInfo={pspPartnerAccountBalanceInfo}
          getTransactionChangeLogs={getTransactionChangeLogs}
          changeLogsIsLoading={changeLogsIsLoading}
          users={users}
          transactionChangeLogsPagination={transactionChangeLogsPagination}
          changeLogsIsFetching={changeLogsIsFetching}
          onResetTransactionWarningAction={onResetTransactionWarningAction}
          resetTransactionsWarningIsLoading={resetTransactionsWarningIsLoading}
          resetTransactionsWarningIsSuccess={resetTransactionsWarningIsSuccess}
          documentsPagination={documentsPagination}
          documentsIsFetching={documentsIsFetching}
          attachedDocumentsErrors={attachedDocumentsErrors}
          uploadedDocumentsErrors={uploadedDocumentsErrors}
          transactionComments={transactionComments}
          transactionCommentsPagination={transactionCommentsPagination}
          getTransactionCommentsAction={getTransactionCommentsAction}
          commentsIsLoading={commentsIsLoading}
          commentsIsFetching={commentsIsFetching}
          onAddCommentToTransaction={onAddCommentToTransaction}
          addCommentInProgress={addCommentInProgress}
          addCommentIsSuccess={addCommentIsSuccess}
          onEditCommentInTransaction={onEditCommentInTransaction}
          editTransactionCommentInProgress={editTransactionCommentInProgress}
          editTrancastionCommentIsSuccess={editTrancastionCommentIsSuccess}
          onDeleteCommentInTransaction={onDeleteCommentInTransaction}
          deleteCommentInTransactionInProgress={
            deleteCommentInTransactionInProgress
          }
          deleteCommentInTranscationIsSuccess={
            deleteCommentInTranscationIsSuccess
          }
          getIncomingTransactionWarningById={getIncomingTransactionWarningById}
          isWarningByIdFetching={isWarningByIdFetching}
          isWarningByIdLoading={isWarningByIdLoading}
          warningsInfo={warningsInfo}
          selectedWarningId={selectedWarningId}
          pspPartnerAccountsPagination={pspPartnerAccountsPagination}
          pspPartnerAccountsNextPageIsLoading={
            pspPartnerAccountsNextPageIsLoading
          }
          pspPartnerAccountsOnScroll={pspPartnerAccountsOnScroll}
          warningActionError={warningActionError}
          clearErrors={clearErrors}
          setWithTime={setWithTime}
          withTime={withTime}
        />
      );
    } else if (!createAllowed && isCreateForm) {
      content = <PermissionDenied />;
    }
  } else if (internalError) {
    content = <div className={styles.internalError}>{internalError}</div>;
  } else {
    content = (
      <IncomingTransactionSidepanelContentRead
        tabs={tabs}
        parentRef={scrollRef}
        parentScroll={scroll}
        warnings={warnings}
        setSubPanelVisible={setSubPanelVisible}
        setSelectedDocumentName={setSelectedDocumentName}
        getTransactionDocument={getTransactionDocument}
        sendMessage={sendMessage}
        deletedAt={transactionInfo?.deletedAt}
      />
    );
  }

  if (checkError) {
    contentError = checkError;
  } else if (errors) {
    contentError = 'There are errors in some fields';
  } else if (errorSidepanel) {
    contentError = errorSidepanel;
  }

  let footerButton;

  if (baseellaStatus !== BaseellaStatus.NOT_SIGNED && enableEdit) {
    if (transactionId && isEditable) {
      footerButton = (
        <ButtonPrimary
          text="Save"
          disabled={isDisabledSaveButton}
          onClick={() => setConfirmationPopupVisible(true)}
          bold
        />
      );
    } else if (isCreateForm && createAllowed) {
      footerButton = (
        <ButtonPrimary
          text={createIsLoading ? 'Loading...' : 'Save'}
          disabled={isDisabledSaveButton}
          onClick={sendCode}
          bold
        />
      );
    }
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={transactionSidePanelVisible}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title={title}
        footerVisible={enableEdit}
        className={styles.transactionSidepanel}
        errorSidepanel={contentError || statusChangeError}
        childrenRef={scrollRef}
        checkInProgress={checkInProgress}
        transactionCheckError={transactionCheckError}
        checkText="Checking transaction..."
        sidepanelExpandedKey={sidepanelExpandedKey}
        footer={
          <>
            {!internalError && footerButton}
            {!isLoading && (
              <>
                {transactionId && onDuplicate && (
                  <ButtonSecondary
                    text="Duplicate"
                    onClick={onDuplicate}
                    className={styles.duplicateButton}
                    disabled={Boolean(
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      updateIsLoading,
                    )}
                    bold
                  />
                )}
                {!internalError && transactionId && !deleteDisabled && (
                  <ButtonSecondary
                    text={
                      deleteTransactionInProgress
                        ? 'Loading...'
                        : 'Delete transaction'
                    }
                    className={`button-white button-warning ${styles.deleteTransactionButton}`}
                    disabled={
                      deleteTransactionInProgress ||
                      deleteTransactionDisabled ||
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      updateIsLoading
                    }
                    onClick={() => setDeleteTransactionPopupVisible(true)}
                    bold
                  />
                )}
              </>
            )}

            <ButtonPseudo text="Cancel" onClick={handleClose} bold />
          </>
        }
      >
        <>
          {children}
          {content}
        </>
      </SidePanel>
      <GeneralLedgerSidepanel
        panelIsOpen={glTransactionSidepanelVisible}
        handleClose={() => {
          if (clearGlTransactionState) {
            clearGlTransactionState();
          }
          setTransactionSidepanelVisible(true);

          setGlTransactionSidePanelVisible(false);
          setActiveTab(EnumTabs.GL_TRANSACTIONS);
        }}
        transaction={glTransaction}
        isLoading={glTransactionIsLoading as boolean}
        title="GL Transaction"
        debitAccountBalance={expandedGLTransactionDebitBalance}
        creditAccountBalance={expandedGLTransactionCreditBalance}
        debitBalanceIsLoading={expendedDebitBalanceIsLoading}
        creditBalanceIsLoading={expendedCreditBalanceIsLoading}
        sidepanelExpandedKey="incoming-gl-transaction"
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={subPanelVisible}
        onClose={() => {
          setSubPanelVisible(false);
          setSelectedDocumentName('');
          setTransactionSidepanelVisible(true);
          setActiveTab(EnumTabs.DOCUMENTS);
        }}
        title={selectedDocumentName}
        className={styles.subPanel}
        sidepanelExpandedKey="incoming-document-sidepanel"
        footer={
          <>
            {((transactionInfo?.recipientAccount?.organization?.type ===
              CustomerType.INDIVIDUAL &&
              activePermission?.includes(
                PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
              )) ||
              (transactionInfo?.recipientAccount?.organization?.type ===
                CustomerType.CORPORATE &&
                activePermission?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                ))) &&
              documentItem && (
                <>
                  {documentItem.status !== DocumentStatus.ACCEPTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          statusChangeInProgress &&
                          selectedStatus === DocumentStatus.ACCEPTED
                            ? 'Loading...'
                            : 'Accept'
                        }
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.ACCEPTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.ACCEPTED,
                            });
                          }
                        }}
                        disabled={statusChangeInProgress || documentIsLoading}
                        bold
                      />
                    )}
                  {documentItem.status !== DocumentStatus.REJECTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          statusChangeInProgress &&
                          selectedStatus === DocumentStatus.REJECTED
                            ? 'Loading...'
                            : 'Reject'
                        }
                        className={styles.rejectStatusButton}
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.REJECTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.REJECTED,
                            });
                          }
                        }}
                        disabled={statusChangeInProgress || documentIsLoading}
                        bold
                      />
                    )}
                </>
              )}
            <ButtonPseudo
              text="Close"
              onClick={() => {
                setSubPanelVisible(false);
                setSelectedDocumentName('');
                setTransactionSidepanelVisible(true);
                setActiveTab(EnumTabs.DOCUMENTS);
              }}
              className="button-white"
              bold
            />
          </>
        }
      >
        {documentIsLoading ? (
          <SidePanelLoader />
        ) : (
          <DocumentSidePanel
            document={documentItem}
            documentFileIsLoading={documentFileIsLoading}
            downloadInProgress={downloadInProgress}
            imgLink={imgLink}
            setDeletePopupVisible={setDeletePopupVisible}
            onMove={onMove}
            moveInProgress={moveInProgress}
            onDownload={onDownload}
            deleteIsVisible={deleteIsVisible}
            customerType={transactionInfo?.recipientAccount?.organization?.type}
            commentsVisible={activePermission?.includes(
              PermissionEnum.DOCUMENTS_COMMENTS_ACTION,
            )}
            sendComment={sendComment}
            editComment={editComment}
            editCommentInProgress={editCommentInProgress}
            editCommentIsSuccess={editCommentIsSuccess}
            deleteComment={deleteComment}
            deleteCommentInProgress={deleteCommentInProgress}
            commentInProgress={commentInProgress}
            activePermissions={activePermission}
            onDownloadSuccess={onDownloadSuccess}
          />
        )}
      </SidePanel>
      <Popup
        title="Delete transaction?"
        onCancelClick={() => setDeleteTransactionPopupVisible(false)}
        onOkClick={() =>
          onDeleteTransactions && onDeleteTransactions(transactionId as string)
        }
        cancelButtonText="Cancel"
        okButtonText={deleteTransactionInProgress ? 'Loading...' : 'Delete'}
        isVisible={deleteTransactionPopupVisible}
        isLoading={deleteTransactionInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      >
        <div>
          {deleteTransactionError && (
            <div className={styles.transactionDeleteError}>
              {deleteTransactionError}
            </div>
          )}
        </div>
      </Popup>
      <Popup
        title={`Delete ${documentItem?.name}`}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={() => onDelete && onDelete(documentItem?.id as string)}
        cancelButtonText="Cancel"
        okButtonText={deleteInProgress ? 'Loading...' : 'Delete'}
        isVisible={deletePopupVisible}
        isLoading={deleteInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      />
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <Popup
        title="You have unsaved changed"
        description="You want to change the status of a transaction, but you have unsaved changes on the transaction. Please select one of the following options:"
        onCancelClick={() =>
          setStatusPopupVisible && setStatusPopupVisible(false)
        }
        onOkClick={onChangeStatusPopup}
        isLoading={onChangeStatusPopupLoading}
        cancelButtonText="Cancel"
        okButtonText="Save changes and change status"
        isVisible={Boolean(statusPopupVisible)}
        parent={document.getElementById('status-popup') as HTMLElement}
      />
      <SignaturePopup
        signaturePopupVisible={signaturePopupVisible}
        validateCode={validateCode}
        validateCodeInProgress={validateCodeInProgress}
        errorMessageSignature={errorMessageSignature}
        onSignatureCancelClick={onSignatureCancelClick}
      />
      <Popup
        title="The transaction will be rejected"
        onCancelClick={() =>
          setRejectPopupVisible && setRejectPopupVisible(false)
        }
        onOkClick={onReject}
        cancelButtonText="Cancel"
        okButtonText="Yes, Reject"
        isVisible={rejectPopupVisible as boolean}
        parent={document.getElementById('signature-popup') as HTMLElement}
        isLoading={rejectInProgress}
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistDataVisible}
        onClose={handleCloseBlacklistData}
        title={blacklistData?.fullName as string}
        parent={
          document.getElementById('blacklist-data-sidepanel') as HTMLElement
        }
        className={styles.transactionSidepanel}
        footer={
          <ButtonPseudo text="Close" onClick={handleCloseBlacklistData} bold />
        }
        sidepanelExpandedKey="incoming-blacklist-data"
      >
        <BlacklistDataContent data={blacklistData} />
      </SidePanel>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistItemVisible}
        onClose={handleCloseBlacklistData}
        title="User Details"
        parent={
          document.getElementById('blacklist-data-sidepanel') as HTMLElement
        }
        className={styles.transactionSidepanel}
        footer={
          <ButtonPseudo text="Close" onClick={handleCloseBlacklistData} bold />
        }
        sidepanelExpandedKey="incoming-blacklist-data"
        withoutExpand
        expanded
      >
        <BlacklistUserInfo info={blacklistItem} isLoading={false} />
      </SidePanel>
      <Popup
        title="Are you sure to save all changes?"
        onCancelClick={() => setConfirmationPopupVisible(false)}
        onOkClick={handleSubmit}
        isLoading={updateIsLoading}
        cancelButtonText="Cancel"
        okButtonText={updateIsLoading ? 'Loading...' : 'Save changes'}
        isVisible={confirmationPopupVisible}
        parent={document.getElementById('status-popup') as HTMLElement}
        okButtonDisabled={updateIsLoading}
      />
      <div id="status-popup" />
      <div id="dirty-popup" />
      <div id="signature-popup" />
      <div id="blacklist-data-sidepanel" />
      <div id="delete-popup-wrapper" />
    </>
  );
}
